export const hiddenKeysConfig = [
  'new_header_send_sms',
  'new_header_call_tool_bar',
  'new_header_person_setting_language',
  'base-routes-leaveMsg',
  'base-routes-call',
  'base-routes-robot',
  'base-routes-ticket',
  'base-routes-robot-call',
  'chat_center_work_footer_clue_card',
  'chat_center_work_footer_evaluation',
  'chat_center_work_header_ticket',
  'chat_center_work_header_leave_message',
  'chat_left_visitor_queue',
  'chat_setting_modal_layout_translate',
  'customer_card_drawer_ticket',
  'customer_card_drawer_call',
  'datascreen_today_visitor',
  'datascreen_home_call_center',
  'datascreen_service_statistics_evalutaion',
  'datascreen_service_status',
  'history_main_right_field_col_evaluation',
  'home_page_queue monitoring',
  'home_page_block_status_invite_evaluation',
  'home_page_block_status_good_evaluation',
  'report-home-queue',
  'report-home-webconvs',
  'report-home-agent-status',
  'report-home-call',
  'report-home-ticket-report-setting',
  'new_report_conv_evaluate',
  'new_report_conv_Queue',
  'visit_ip_blacklist',
  'chat_rule_history_conv',
  'auto_end_web_sdk_item',
  'extend_function_remove_send_function',
  'extend_function_remove_recall',
  'team_agent_modal_call',
  'team_agent_modal_ticket',
  'team_agent_block_title_info',
  'business_visitor_block_visiting',
  'business_visitor_block_keyword',
  'business_visitor_block_baidu',
  'business_visitor_block_follow_source',
  'business_visitor_block_system',
  'business_visitor_block_device',
  'business_visitor_block_browser',
  'business_visitor_block_ip',
  'new_header_official_email',
  'setting_payment_contact',
  'auth_register_success_btn_desc',
  'auth_register_success',
  'chat_center_work_footer_robot',
  'agent_assign_pre_form',
  'chat_left_custom_mode_visitor',
  'chat_left_custom_mode_queue',
  'enable_account_count_limit',
  'notification_ticket_api',
  'track_point_api',
  'redbook_intended_comment',
  'hight_assign_tooltips',
  'agent_rule_modal_tooltips',
  'agent_rule_modal_select_width',
  'register_limit',
  'invoice_black_list'
];
